export default "/_next/static/images/header-bg-c88359c0941f6c3a9e552433e6ce4281.png";